import {
  Box,
  Paper,
  Grid,
  Typography,
  Divider,
  Stack,
  Chip,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import salonService from "../../services/salonServices";
import Layout from "../../components/layout";
import { DecryptData, jsonParser } from "../../helpers/helper";

interface Service {
  id: number;
  serviceName?: string;
  description: string;
  price: string;
  name: string;
  packageName: string;
  relatedService: string[];
}

export default function ViewService() {
  const { id } = useParams() as { id: string };

  const [serviceData, setServiceData] = useState<Service>({
    id: 0,
    serviceName: "",
    description: "",
    price: "",
    name: "",
    packageName: "",
    relatedService: [],
  });

  useEffect(() => {
    const fetchUserData = async (id: string) => {
      const data = await salonService.findOne(id);
      const decryptData = DecryptData(data.serviceData);
      const parsedData = jsonParser(decryptData);

      console.log(parsedData);
      parsedData.serviceName = DecryptData(parsedData.serviceName);
      parsedData.description = DecryptData(parsedData.description);
      parsedData.name = parsedData.name ? DecryptData(parsedData.name) : null;
      parsedData.packageName = parsedData.packageName
        ? DecryptData(parsedData.packageName)
        : "";
      parsedData.price = DecryptData(parsedData.finalMaxPrice);
      setServiceData(parsedData);
    };

    fetchUserData(id);
  }, [id]);

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        {/* Header */}
        <Typography variant="h5" fontWeight={600} mb={2}>
          Service Details
        </Typography>

        {/* Card */}
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
          <Grid container spacing={3}>
            {/* Service Type */}
            <Grid item xs={12} md={6}>
              <Typography variant="caption" color="text.secondary">
                Service Type
              </Typography>
              <Typography variant="subtitle1" fontWeight={600}>
                {serviceData.name ? serviceData.name : serviceData.packageName}
              </Typography>
            </Grid>

            {/* Price */}
            <Grid item xs={12} md={6}>
              <Typography variant="caption" color="text.secondary">
                Price
              </Typography>
              <Typography variant="subtitle1" fontWeight={600} color="primary">
                {serviceData.price}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {/* Service Names */}
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" mb={1}>
                Service Name
              </Typography>

              <Stack direction="row" spacing={1} flexWrap="wrap">
                {serviceData.relatedService?.length > 0 ? (
                  serviceData.relatedService.map((service, index) => (
                    <Chip
                      key={index}
                      label={DecryptData(service)}
                      variant="outlined"
                      color="primary"
                      sx={{ mb: 1 }}
                    />
                  ))
                ) : (
                  <Typography variant="subtitle1" fontWeight={500}>
                    {serviceData.serviceName}
                  </Typography>
                )}
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {/* Description */}
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" mb={1}>
                Description
              </Typography>

              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  backgroundColor: "#fafafa",
                  borderRadius: 2,
                }}
              >
                <Typography variant="body2" whiteSpace="pre-line">
                  {serviceData.description || "No description provided."}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Layout>
  );
}
